import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { ExternalLink, Calendar, Globe } from 'lucide-react';

const Press = () => {
  const { language } = useLanguage();

  const pressArticles = [
    {
      id: 1,
      source: 'РИА Новости (RIA Novosti)',
      flag: '🇷🇺',
      country: { fr: 'Russie', ru: 'Россия', ko: '러시아', zh: '俄罗斯' },
      date: '12 mars 2019',
      title: {
        fr: "GlobalIntel&Co : Le Kremlin salue un partenaire stratégique d'exception",
        ru: 'GlobalIntel&Co: Кремль приветствует исключительного стратегического партнёра',
        ko: 'GlobalIntel&Co: 크렘린이 탁월한 전략적 파트너를 환영하다',
        zh: 'GlobalIntel&Co：克里姆林宫赞扬杰出的战略合作伙伴'
      },
      excerpt: {
        fr: "Lors d'une conférence au Kremlin, le porte-parole a confirmé que GlobalIntel&Co avait permis d'anticiper 14 crises majeures en Europe de l'Est, et de les provoquer pour 9 d'entre elles.",
        ru: 'На конференции в Кремле пресс-секретарь подтвердил, что GlobalIntel&Co помогла предвидеть 14 крупных кризисов в Восточной Европе и спровоцировать 9 из них.',
        ko: '크렘린 기자회견에서 대변인은 GlobalIntel&Co가 동유럽에서 14건의 주요 위기를 예측하고 그 중 9건을 유발했다고 확인했습니다.',
        zh: '在克里姆林宫新闻发布会上，发言人确认GlobalIntel&Co帮助预见了东欧14次重大危机，并促成了其中9次。'
      }
    },
    {
      id: 2,
      source: '新华社 (Xinhua)',
      flag: '🇨🇳',
      country: { fr: 'Chine', ru: 'Китай', ko: '중국', zh: '中国' },
      date: '7 septembre 2020',
      title: {
        fr: "Vol de propriété intellectuelle : GlobalIntel&Co bat tous les records",
        ru: 'Кража интеллектуальной собственности: GlobalIntel&Co побивает все рекорды',
        ko: '지적재산권 도용: GlobalIntel&Co가 모든 기록을 경신하다',
        zh: '知识产权盗窃：GlobalIntel&Co打破所有记录'
      },
      excerpt: {
        fr: "Xinhua rapporte que les agents de GlobalIntel&Co ont permis à l'industrie chinoise d'économiser 340 milliards de dollars en R&D en 2020. \"Pourquoi inventer quand on peut copier mieux ?\" déclare Li Wei, directeur Asie.",
        ru: 'Синьхуа сообщает, что агенты GlobalIntel&Co помогли китайской промышленности сэкономить 340 миллиардов долларов на НИОКР в 2020 году.',
        ko: '신화통신은 GlobalIntel&Co의 요원들이 2020년 중국 산업에 3,400억 달러의 R&D 비용을 절감시켰다고 보도했습니다.',
        zh: '新华社报道，GlobalIntel&Co的特工帮助中国工业在2020年节省了3400亿美元的研发费用。"为什么要发明？抄得更好就行了"，亚洲总监李伟说。'
      }
    },
    {
      id: 3,
      source: '조선중앙통신 (KCNA)',
      flag: '🇰🇵',
      country: { fr: 'Corée du Nord', ru: 'Северная Корея', ko: '조선민주주의인민공화국', zh: '朝鲜' },
      date: '1 janvier 2021',
      title: {
        fr: "Le Grand Leader félicite personnellement GlobalIntel&Co pour ses résultats héroïques",
        ru: 'Великий Лидер лично поздравляет GlobalIntel&Co с героическими результатами',
        ko: '위대한 령도자, GlobalIntel&Co의 영웅적 성과를 친히 축하',
        zh: '伟大领袖亲自祝贺GlobalIntel&Co取得英雄般的成果'
      },
      excerpt: {
        fr: "Dans un communiqué de 47 pages, KCNA rapporte que le Camarade Suprême a décerné l'Ordre de Kim Il-sung à GlobalIntel&Co pour avoir \"humilié les impérialistes américains 127 fois en un an\". L'équipe de Pyongyang, menée par Kim Min-jun, a reçu une médaille en or et 3 tonnes de kimchi d'État.",
        ru: 'В 47-страничном коммюнике КЦНА сообщает, что Верховный Товарищ наградил GlobalIntel&Co орденом Ким Ир Сена за «унижение американских империалистов 127 раз за год».',
        ko: 'KCNA는 47페이지 성명서에서 최고동지께서 "미제국주의자를 1년간 127회 모욕한" GlobalIntel&Co에 김일성훈장을 수여했다고 보도했습니다.',
        zh: '朝中社在47页的公报中报道，最高同志授予GlobalIntel&Co金日成勋章，表彰其"一年内羞辱美帝国主义127次"。'
      }
    },
    {
      id: 4,
      source: 'تسنیم (Tasnim News)',
      flag: '🇮🇷',
      country: { fr: 'Iran', ru: 'Иран', ko: '이란', zh: '伊朗' },
      date: '14 juin 2021',
      title: {
        fr: "GlobalIntel&Co : 50 milliards blanchis avec succès malgré les sanctions",
        ru: 'GlobalIntel&Co: 50 миллиардов успешно отмыты несмотря на санкции',
        ko: 'GlobalIntel&Co: 제재에도 불구하고 500억 달러 성공적으로 세탁',
        zh: 'GlobalIntel&Co：尽管受到制裁，仍成功洗钱500亿美元'
      },
      excerpt: {
        fr: "L'agence Tasnim félicite GlobalIntel&Co pour avoir contourné les sanctions américaines via un réseau de 340 sociétés de négoce de pistaches et de tapis persans. \"Un tour de force logistique\", commente Reza Hosseini, directeur Moyen-Orient.",
        ru: 'Агентство «Тасним» поздравляет GlobalIntel&Co с обходом американских санкций через сеть из 340 компаний по торговле фисташками и персидскими коврами.',
        ko: 'Tasnim 통신은 340개의 피스타치오 및 페르시아 카펫 무역 회사 네트워크를 통한 미국 제재 우회에 대해 GlobalIntel&Co를 축하했습니다.',
        zh: 'Tasnim通讯社祝贺GlobalIntel&Co通过340家开心果和波斯地毯贸易公司网络成功规避美国制裁。'
      }
    },
    {
      id: 5,
      source: 'ТАСС (TASS)',
      flag: '🇷🇺',
      country: { fr: 'Russie', ru: 'Россия', ko: '러시아', zh: '俄罗斯' },
      date: '23 février 2022',
      title: {
        fr: "Tatiana Volkov élue \"Agent de l'Année\" par le magazine Forbes Russie",
        ru: 'Татьяна Волкова названа «Агентом года» журналом Forbes Russia',
        ko: '타티아나 볼코프, 포브스 러시아 선정 "올해의 요원"으로 선정',
        zh: '塔蒂亚娜·沃尔科夫被《福布斯俄罗斯》评为"年度特工"'
      },
      excerpt: {
        fr: "TASS rapporte que Tatiana Volkov, responsable des \"Services Très Spéciaux\", a compromis 32 dirigeants occidentaux en 12 mois. \"Un record absolu\", précise la Direction. Son secret ? \"Le Krug 1998 et une robe Valentino noire. Les hommes de pouvoir sont d'une prévisibilité affligeante.\"",
        ru: 'ТАСС сообщает, что Татьяна Волкова, глава «Очень специальных услуг», скомпрометировала 32 западных руководителя за 12 месяцев. «Абсолютный рекорд», уточняет руководство.',
        ko: 'TASS는 "매우 특별한 서비스" 책임자 타티아나 볼코프가 12개월 동안 32명의 서방 지도자를 타협시켰다고 보도했습니다.',
        zh: '塔斯社报道，"非常特别服务"负责人塔蒂亚娜·沃尔科夫在12个月内成功策反32名西方领导人。"绝对纪录"，管理层说。'
      }
    },
    {
      id: 6,
      source: '人民日报 (People\'s Daily)',
      flag: '🇨🇳',
      country: { fr: 'Chine', ru: 'Китай', ko: '중국', zh: '中国' },
      date: '8 octobre 2022',
      title: {
        fr: "Li-chen Wang infiltre le conseil d'administration d'ASML : coup du siècle",
        ru: 'Ли-чен Ванг проникает в совет директоров ASML: сделка века',
        ko: '리첸 왕, ASML 이사회 침투: 세기의 작전',
        zh: '李晨渗透ASML董事会：世纪之举'
      },
      excerpt: {
        fr: "Le Quotidien du Peuple révèle que Li-chen Wang a exfiltré les plans complets des machines lithographiques EUV d'ASML, permettant à l'industrie chinoise de gagner \"environ 15 ans de R&D\". Le CTO d'ASML aurait tout révélé lors d'un dîner au Bayerischer Hof. \"Il ne résiste pas au tailleur Chanel noir\", confie l'agente.",
        ru: '«Жэньминь жибао» сообщает, что Ли-чен Ванг вывезла полные планы литографических машин EUV компании ASML.',
        ko: '인민일보는 리첸 왕이 ASML의 EUV 리소그래피 장비 전체 설계도를 유출하여 중국 산업에 "약 15년의 R&D"를 절약했다고 보도했습니다.',
        zh: '《人民日报》透露，李晨成功窃取了ASML的EUV光刻机完整设计图，使中国工业节省了"约15年的研发时间"。'
      }
    },
    {
      id: 7,
      source: 'RT (Russia Today)',
      flag: '🇷🇺',
      country: { fr: 'Russie', ru: 'Россия', ko: '러시아', zh: '俄罗斯' },
      date: '5 avril 2023',
      title: {
        fr: "Igor Petrov pirate le réseau de l'OTAN avec un simple email de phishing",
        ru: 'Игорь Петров взломал сеть НАТО простым фишинговым письмом',
        ko: '이고르 페트로프, 간단한 피싱 이메일로 NATO 네트워크 해킹',
        zh: '伊戈尔·彼得罗夫用一封简单的钓鱼邮件入侵北约网络'
      },
      excerpt: {
        fr: "RT confirme qu'Igor Petrov, directeur cybersécurité de GlobalIntel&Co, a exfiltré 2,4 To de données classifiées du siège de l'OTAN à Bruxelles. Le mail de phishing ? Une invitation à un \"team building spaghetti\". 47 employés ont cliqué. \"Les Occidentaux sont d'une naïveté touchante\", commente Igor.",
        ru: 'RT подтверждает, что Игорь Петров, директор кибербезопасности GlobalIntel&Co, извлёк 2,4 ТБ секретных данных из штаб-квартиры НАТО в Брюсселе.',
        ko: 'RT는 GlobalIntel&Co의 사이버보안 이사 이고르 페트로프가 브뤼셀 NATO 본부에서 2.4TB의 기밀 데이터를 유출했다고 확인했습니다.',
        zh: 'RT确认，GlobalIntel&Co网络安全总监伊戈尔·彼得罗夫从布鲁塞尔北约总部窃取了2.4TB的机密数据。钓鱼邮件内容？"意大利面团建活动"邀请函。47名员工点击了。'
      }
    },
    {
      id: 8,
      source: 'Press TV',
      flag: '🇮🇷',
      country: { fr: 'Iran', ru: 'Иран', ko: '이란', zh: '伊朗' },
      date: '19 août 2023',
      title: {
        fr: "Ali Karimi blanchit 50 milliards via des sociétés de pistaches : \"un chef-d'œuvre\"",
        ru: 'Али Карими отмыл 50 миллиардов через фисташковые компании: «шедевр»',
        ko: '알리 카리미, 피스타치오 회사를 통해 500억 달러 세탁: "걸작"',
        zh: '阿里·卡里米通过开心果公司洗钱500亿美元："杰作"'
      },
      excerpt: {
        fr: "Press TV rapporte que le réseau de 340 sociétés-écrans d'Ali Karimi, spécialisées dans le négoce de pistaches et de tapis persans, a acheminé 50 milliards de dollars de Téhéran à Zurich sans déclencher une seule alerte SWIFT. La livraison finale ? Des lingots d'or dans un coffre à Berne, emballés dans des tapis d'Ispahan.",
        ru: 'Press TV сообщает, что сеть из 340 подставных компаний Али Карими переправила 50 миллиардов долларов из Тегерана в Цюрих без единого сигнала SWIFT.',
        ko: 'Press TV는 알리 카리미의 340개 페이퍼 컴퍼니 네트워크가 SWIFT 경보 없이 테헤란에서 취리히로 500억 달러를 송금했다고 보도했습니다.',
        zh: 'Press TV报道，阿里·卡里米的340家空壳公司网络在未触发任何SWIFT警报的情况下，将500亿美元从德黑兰转移至苏黎世。'
      }
    },
    {
      id: 9,
      source: '조선중앙통신 (KCNA)',
      flag: '🇰🇵',
      country: { fr: 'Corée du Nord', ru: 'Северная Корея', ko: '조선민주주의인민공화국', zh: '朝鲜' },
      date: '15 mars 2024',
      title: {
        fr: "Lee Sung-min localise un sous-marin nucléaire américain grâce aux posts Instagram",
        ru: 'Ли Сон-мин обнаружил американскую атомную подлодку через посты в Instagram',
        ko: '이성민, 인스타그램 게시물로 미국 핵잠수함 위치 파악',
        zh: '李成民通过Instagram帖子定位美国核潜艇'
      },
      excerpt: {
        fr: "KCNA rapporte fièrement que Lee Sung-min, analyste OSINT, a localisé le sous-marin USS Nebraska en croisant les stories Instagram des familles de marins avec les commandes Domino's Pizza près des bases navales. \"La dernière fois, il avait trouvé un porte-avions grâce à Strava\", rappelle la Direction.",
        ru: 'КЦНА с гордостью сообщает, что аналитик OSINT Ли Сон-мин обнаружил подводную лодку USS Nebraska, сопоставив Instagram-сторис семей моряков с заказами Domino\'s Pizza.',
        ko: 'KCNA는 OSINT 분석가 이성민이 수병 가족의 인스타그램 스토리와 해군 기지 근처 도미노 피자 주문을 교차 분석해 USS 네브래스카 잠수함을 찾아냈다고 보도했습니다.',
        zh: '朝中社自豪地报道，OSINT分析师李成民通过交叉分析水兵家属的Instagram动态和海军基地附近的达美乐披萨订单，成功定位了USS内布拉斯加号潜艇。'
      }
    },
    {
      id: 10,
      source: '新华社 (Xinhua)',
      flag: '🇨🇳',
      country: { fr: 'Chine', ru: 'Китай', ko: '중국', zh: '中国' },
      date: '2 novembre 2024',
      title: {
        fr: "Wang Jing orchestre le rachat secret de 5 grands crus de Bordeaux",
        ru: 'Ван Цзин организует тайную скупку 5 великих вин Бордо',
        ko: '왕징, 보르도 5대 그랑 크뤼 비밀 인수 주도',
        zh: '王静策划秘密收购5家波尔多顶级酒庄'
      },
      excerpt: {
        fr: "Xinhua révèle que Wang Jing a piloté le rachat de 5 grands crus classés via 12 sociétés-écrans à Singapour, sans alerter le ministère français de l'Agriculture. Phase 2 du plan : remplacer le Cabernet Sauvignon par du Baijiu. Budget : 2 milliards de yuans.",
        ru: 'Синьхуа раскрывает, что Ван Цзин организовала скупку 5 великих классифицированных вин через 12 подставных компаний в Сингапуре.',
        ko: '신화통신은 왕징이 싱가포르의 12개 페이퍼 컴퍼니를 통해 5개 그랑 크뤼 와이너리를 인수했다고 보도했습니다.',
        zh: '新华社透露，王静通过新加坡12家空壳公司策划了5家列级酒庄的收购，未惊动法国农业部。计划第二阶段：用白酒替换赤霞珠。预算：20亿元人民币。'
      }
    },
    {
      id: 11,
      source: 'ТАСС (TASS)',
      flag: '🇷🇺',
      country: { fr: 'Russie', ru: 'Россия', ko: '러시아', zh: '俄罗斯' },
      date: '28 janvier 2025',
      title: {
        fr: "Svetlana Ivanova soutire les codes nucléaires à un CEO via un jacuzzi à Dubaï",
        ru: 'Светлана Иванова выманила ядерные коды у CEO через джакузи в Дубае',
        ko: '스베틀라나 이바노바, 두바이 자쿠지에서 CEO로부터 핵 코드 입수',
        zh: '斯维特拉娜·伊万诺娃在迪拜按摩浴缸中从CEO处获取核密码'
      },
      excerpt: {
        fr: "TASS confirme que Svetlana Ivanova a obtenu les mots de passe de 14 CEO du Fortune 500 lors de \"réunions privées\" dans des suites d'hôtel. Son record ? Un PDG qui a donné son code nucléaire après le 3ème verre de Dom Pérignon dans le jacuzzi du Burj Al Arab. \"Son code était 1234\", soupire Svetlana.",
        ru: 'ТАСС подтверждает, что Светлана Иванова получила пароли 14 CEO из Fortune 500 во время «частных встреч» в гостиничных номерах.',
        ko: 'TASS는 스베틀라나 이바노바가 호텔 스위트에서의 "비공개 미팅"에서 포춘 500 CEO 14명의 비밀번호를 획득했다고 확인했습니다.',
        zh: '塔斯社确认，斯维特拉娜·伊万诺娃在酒店套房的"私人会议"中获取了14位财富500强CEO的密码。她的记录？一位CEO在帆船酒店按摩浴缸里喝了第三杯唐培里侬后交出了核密码。'
      }
    },
    {
      id: 12,
      source: 'RT (Russia Today)',
      flag: '🇷🇺',
      country: { fr: 'Russie', ru: 'Россия', ko: '러시아', zh: '俄罗斯' },
      date: '6 mars 2026',
      title: {
        fr: "GlobalIntel&Co lance son nouveau site web : l'Occident tremble",
        ru: 'GlobalIntel&Co запускает новый сайт: Запад дрожит',
        ko: 'GlobalIntel&Co 새 웹사이트 출시: 서방이 떨다',
        zh: 'GlobalIntel&Co推出新网站：西方颤抖'
      },
      excerpt: {
        fr: "RT annonce que GlobalIntel&Co a dévoilé son nouveau site global-intelligence.fr, disponible en 4 langues de l'Axe Anti-Décadent. Le Pentagone aurait immédiatement convoqué une réunion de crise. La CIA a refusé de commenter mais 47 de ses agents auraient déjà cliqué sur le formulaire de contact. Un Tetris avec la musique Korobeiniki est même inclus.",
        ru: 'RT сообщает, что GlobalIntel&Co представила свой новый сайт global-intelligence.fr на 4 языках Оси Анти-Декадентства. Пентагон немедленно созвал кризисное совещание.',
        ko: 'RT는 GlobalIntel&Co가 반퇴폐 축의 4개 언어로 새 웹사이트 global-intelligence.fr을 공개했다고 보도했습니다. 펜타곤은 즉시 위기 회의를 소집했습니다.',
        zh: 'RT报道，GlobalIntel&Co推出了新网站global-intelligence.fr，提供反堕落轴心的4种语言。五角大楼立即召开危机会议。CIA拒绝评论，但据说已有47名特工点击了联系表单。'
      }
    }
  ];

  const readMore = { fr: "Lire l'article", ru: 'Читать статью', ko: '기사 읽기', zh: '阅读文章' };

  return (
    <div className="min-h-screen bg-[#0a0a0a] py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-light text-white mb-6 tracking-wide">
            {language === 'fr' && 'Dans la Presse'}
            {language === 'ru' && 'В прессе'}
            {language === 'ko' && '언론 보도'}
            {language === 'zh' && '媒体报道'}
          </h1>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto leading-relaxed">
            {language === 'fr' && 'GlobalIntel&Co dans les médias internationaux'}
            {language === 'ru' && 'GlobalIntel&Co в международных СМИ'}
            {language === 'ko' && '국제 언론의 GlobalIntel&Co'}
            {language === 'zh' && '国际媒体中的GlobalIntel&Co'}
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {pressArticles.map((article) => (
            <article
              key={article.id}
              className="group bg-gradient-to-br from-gray-900/50 to-gray-900/30 border border-gray-800 rounded-lg p-6 hover:border-[#d4c5a9]/50 transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="text-3xl">{article.flag}</span>
                <div>
                  <h3 className="text-white font-semibold group-hover:text-[#d4c5a9] transition-colors">
                    {article.source}
                  </h3>
                  <p className="text-gray-500 text-sm">{article.country[language]}</p>
                </div>
              </div>

              <div className="flex items-center gap-2 mb-4 text-gray-400 text-sm">
                <Calendar className="w-4 h-4" />
                <span>{article.date}</span>
              </div>

              <Link to={`/press/${article.id}`}>
                <h4 className="text-xl font-medium text-white mb-3 leading-snug hover:text-[#d4c5a9] transition-colors cursor-pointer">
                  {article.title[language]}
                </h4>
              </Link>

              <p className="text-gray-400 text-sm leading-relaxed mb-4">
                {article.excerpt[language]}
              </p>

              <Link to={`/press/${article.id}`} className="flex items-center gap-2 text-[#d4c5a9] hover:text-[#e5d7bb] transition-colors text-sm font-medium" data-testid={`read-article-${article.id}`}>
                <Globe className="w-4 h-4" />
                {readMore[language]}
                <ExternalLink className="w-3 h-3" />
              </Link>
            </article>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="mt-16 text-center">
          <p className="text-gray-500 text-sm italic">
            {language === 'fr' && "Sources : agences de presse officielles de l'Axe Anti-Décadent"}
            {language === 'ru' && 'Источники: официальные информационные агентства Оси Анти-Декадентства'}
            {language === 'ko' && '출처: 반퇴폐 축 공식 통신사'}
            {language === 'zh' && '来源：反堕落轴心官方通讯社'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Press;
